// 📁 hooks/useVerifyOrder.ts
import { useState } from 'react'

export function useVerifyOrder() {
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState(null)
  const [error, setError] = useState<any>(null)

  const verifyOrder = async (payload: any) => {
    setLoading(true)
    setError(null)

    try {
      const res = await fetch(`${process.env.NEXT_PUBLIC_EPAY_URL}/epay/order/verify`, {
        method: 'POST',
        headers: {
          accept: '*/*',
          'cache-control': 'no-cache',
          'content-type': 'application/json',
        },
        body: payload,
      })

      const data = await res.json()
      setResponse(data)
      return data
    } catch (err) {
      setError(err)
      console.error('Error verifying order:', err)
    } finally {
      setLoading(false)
    }
  }

  return { verifyOrder, loading, response, error }
}
